import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_208: DocMigration = {
  maxSchemaVersion: "0.0.208",
  description: "Move disconnectConditions from OptionSet into DocAuxOptionSet and convert from string to Formula",
  apply(json: any) {
    if (!(json.optionSets !== undefined)) {
      console.assert(false);
    }
    if (json.auxOptionSets === undefined) {
      json.auxOptionSets = {};
    }

    const { optionSets, auxOptionSets } = json;
    for (const id in optionSets) {
      const optionSet = optionSets[id];

      if (optionSet.disconnectConditions) {
        const str = optionSet.disconnectConditions;
        delete optionSets[id].disconnectConditions;
        auxOptionSets[id] = { ...auxOptionSets[id], disconnectCondition: { type: "FORMULA", formula: str } };
      }
    }
    return json;
  },
};

export default migration_0_0_208;
